import '@babel/polyfill';

import Vue from 'vue';

import $ from 'jquery';
window.$ = window.JQuery = window.jQuery = $;
import moment from 'moment';
window.moment = moment;

import './plugins';
import './components';
import './directives';
import './filters';
import './views/Layout';
import '@fortawesome/fontawesome-free/css/all.css';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import { safeGetProp, timeout } from './utils/common';
import httpContext from './utils/httpContext';

import ApiService from './services/ApiService';
import HttpStatusCode from './data/enums/httpStatusCode';
import settings from './data/settings';
import { Geti18nTranslations, i18n } from './plugins/vuei18n';
import VueGtag from 'vue-gtag';

Vue.use(VueGtag, {
  config: { id: 'UA-112759798-2' },
});

Vue.config.productionTip = false;
// Vue.config.devtools = false;
// Vue.config.debug = false;
// Vue.config.silent = true;
var _httpContext = httpContext;

if (!settings.isProd) {
  // Debug
  // let mockHttpContext = require('./mock/mockHttpContext').default;
  // _httpContext = mockHttpContext;
}

export const apiService = new ApiService(_httpContext);

const _eventBus = new Vue();
export const eventBus = _eventBus;

Vue.prototype.$get = safeGetProp;
Vue.prototype.$isDebug = !settings.isProd;
Vue.prototype.$placeholderImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcGg0AAcsBEuRzwtUAAAAASUVORK5CYII=';

const _tisztaTisza = new Vue({
  router,
  i18n: i18n,
  store,
  created() {},
  render: h => h(App),
});
init();

async function init() {
  try {
    await Geti18nTranslations();
  } catch (error) {
    console.log(error);
  }
  _tisztaTisza.$mount('#main');
}

export const tisztaTisza = _tisztaTisza;

//import('./socket');

window.TisztaTisza = {
  app: _tisztaTisza,
  store: store,
  apiService,
};

console.log(
  `📌 Build ideje: ${moment(process.env.VUE_APP_BUILD_TIME).format(
    'YYYY.MM.DD. HH:mm'
  )}`
);
